//#region theme/frontend/islands/color-zones.js
var ColorZones = class extends HTMLElement {
	connectedCallback() {
		this.zones = [...this.querySelectorAll("[data-zone]")];
		this.cursor = this.querySelector("[data-cursor]");
		this.overlay = this.querySelector("[data-blowout-overlay]");
		this.mql = window.matchMedia("(min-width: 768px)");
		this.isDesktop = false;
		this.blownOut = false;
		this.blownOutSrc = this.dataset.blownoutSrc || null;
		this.shakeHistory = [];
		this.boundToggle = () => this.toggle(this.mql.matches);
		this.mql.addEventListener("change", this.boundToggle);
		this.toggle(this.mql.matches);
		this.addEventListener("click", this);
	}
	disconnectedCallback() {
		this.mql.removeEventListener("change", this.boundToggle);
	}
	toggle(desktop) {
		if (desktop && !this.isDesktop) {
			this.isDesktop = true;
			for (const zone of this.zones) {
				zone.style.opacity = .2;
				zone.style.color = "";
			}
			this.addEventListener("mousemove", this);
			this.addEventListener("mouseleave", this);
			this.addEventListener("mouseenter", this);
		} else if (!desktop && this.isDesktop) {
			this.isDesktop = false;
			for (const zone of this.zones) {
				zone.style.opacity = "";
				zone.style.color = "";
			}
			if (this.cursor) this.cursor.classList.add("hidden");
			this.removeEventListener("mousemove", this);
			this.removeEventListener("mouseleave", this);
			this.removeEventListener("mouseenter", this);
		}
	}
	detectShake(x) {
		if (!this.blownOutSrc || this.blownOut) return;
		const now = performance.now();
		const last = this.shakeHistory[this.shakeHistory.length - 1];
		if (last && Math.abs(x - last.x) < 30) return;
		this.shakeHistory.push({
			x,
			t: now
		});
		const cutoff = now - 600;
		while (this.shakeHistory.length && this.shakeHistory[0].t < cutoff) this.shakeHistory.shift();
		if (this.shakeHistory.length < 4) return;
		let reversals = 0;
		for (let i = 2; i < this.shakeHistory.length; i++) if ((this.shakeHistory[i - 1].x - this.shakeHistory[i - 2].x) * (this.shakeHistory[i].x - this.shakeHistory[i - 1].x) < 0) reversals++;
		if (reversals >= 3) {
			this.shakeHistory = [];
			this.blowout();
		}
	}
	blowout() {
		this.blownOut = true;
		const img = this.querySelector("[data-cursor-img]");
		if (img) {
			this.originalSrc = img.src;
			img.src = this.blownOutSrc;
		}
		const svg = this.cursor?.querySelector("svg");
		if (svg) {
			svg.style.animationPlayState = "paused";
			svg.style.scale = "0.4";
			svg.style.opacity = 0;
		}
		for (const zone of this.zones) {
			zone.style.opacity = .2;
			zone.style.color = "";
		}
		if (this.overlay) this.overlay.style.opacity = .6;
		this.relightTimer = setTimeout(() => this.relight(), 4e3);
	}
	relight() {
		this.blownOut = false;
		const img = this.querySelector("[data-cursor-img]");
		if (img && this.originalSrc) img.src = this.originalSrc;
		if (this.overlay) this.overlay.style.opacity = "";
		const svg = this.cursor?.querySelector("svg");
		if (svg) {
			svg.style.animationPlayState = "";
			svg.style.scale = "";
			svg.style.opacity = "";
		}
	}
	handleEvent(e) {
		if (e.type === "click") {
			window.location.href = "/";
			return;
		}
		if (e.type === "mouseenter") {
			if (this.cursor) this.cursor.classList.remove("hidden");
			return;
		}
		if (e.type === "mouseleave") {
			for (const zone of this.zones) {
				zone.style.color = "";
				zone.style.opacity = .2;
			}
			if (this.cursor) this.cursor.classList.add("hidden");
			return;
		}
		if (this.cursor) this.cursor.style.transform = `translate(calc(${e.clientX}px - 50%), calc(${e.clientY}px - 50%))`;
		this.detectShake(e.clientX);
		if (this.blownOut) return;
		const y = e.clientY;
		const threshold = window.innerHeight * .35;
		for (const zone of this.zones) {
			const rect = zone.getBoundingClientRect();
			const centerY = rect.top + rect.height / 2;
			const dist = Math.abs(y - centerY);
			const t = Math.min(1, Math.max(0, 1 - dist / threshold));
			const pct = Math.round(t * 100);
			const opacity = .2 + t * .8;
			zone.style.color = pct > 0 ? `color-mix(in srgb, #FFEF03 ${pct}%, #ffffff)` : "";
			zone.style.opacity = opacity;
		}
	}
};
customElements.define("color-zones", ColorZones);
//#endregion
